// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-page-header-heading-title {
  font-size: 1.4rem;
  font-weight: 400;
}
body {
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
}
.ant-menu-inline .ant-menu-item {
  font-size: 18px;
}
.rs-table-row-header .rs-table-cell {
  text-transform: uppercase;
}
.rs-table-cell-header .rs-table-cell-content {
  padding: 7px 10px;
  font-size: 14px;
  font-weight: normal;
  color: #000;
}
a,
.ant-btn-link {
  color: #044c80;
}
.ant-input:hover,
.ant-select-selection:hover {
  border-color: #044c80 !important;
}
.ant-input:focus,
.ant-select-focused .ant-select-selection,
.ant-select-selection:focus,
.ant-select-selection:active {
  border-color: #044c80 !important;
  box-shadow: 0 0 0 2px rgba(28, 78, 114, 0.2) !important;
}
.ant-menu-inline > .ant-menu-item {
  height: 50px !important;
  line-height: 50px !important;
}
.flex_space_between {
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/index.less"],"names":[],"mappings":"AAQA;EACI,iBAAA;EACA,gBAAA;AAPJ;AAUA;EACI,SAAA;EACA,UAAA;EACA,8IAAA;AARJ;AAWA;EACI,eAAA;AATJ;AAYA;EACI,yBAAA;AAVJ;AAaA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAXJ;AAcA;;EAEI,cAAA;AAZJ;AAeA;;EAEI,gCAAA;AAbJ;AAgBA;;;;EAII,gCAAA;EACA,uDAAA;AAdJ;AAiBA;EACI,uBAAA;EACA,4BAAA;AAfJ;AAkBA;EACI,aAAA;EACA,8BAAA;AAhBJ","sourcesContent":["// @import \"~rsuite/styles/index.less\";\n// @import '~antd/dist/antd.less';\n// @layout-header-background: #ffffff;\n// @layout-sider-background: #044c80;\n// @primary-color: #c86a1d;\n// @layout-body-background: #ffffff;\n// @menu-dark-color: #ffffff;\n\n.ant-page-header-heading-title {\n    font-size: 1.4rem;\n    font-weight: 400;\n}\n\nbody {\n    margin: 0;\n    padding: 0;\n    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n\n.ant-menu-inline .ant-menu-item {\n    font-size: 18px;\n}\n\n.rs-table-row-header .rs-table-cell {\n    text-transform: uppercase;\n}\n\n.rs-table-cell-header .rs-table-cell-content {\n    padding: 7px 10px;\n    font-size: 14px;\n    font-weight: normal;\n    color: #000;\n}\n\na,\n.ant-btn-link {\n    color: #044c80;\n}\n\n.ant-input:hover,\n.ant-select-selection:hover {\n    border-color: #044c80 !important;\n}\n\n.ant-input:focus,\n.ant-select-focused .ant-select-selection,\n.ant-select-selection:focus,\n.ant-select-selection:active {\n    border-color: #044c80 !important;\n    box-shadow: 0 0 0 2px rgba(28, 78, 114, 0.2) !important;\n}\n\n.ant-menu-inline>.ant-menu-item {\n    height: 50px !important;\n    line-height: 50px !important;\n}\n\n.flex_space_between {\n    display: flex;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
